/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

function withTitle<T>(ComposedComponent, title: string) {
  const ComponentWithTitle = (props: T): JSX.Element => {
    const location = useLocation();

    useEffect(() => {
      document.title = `${title} | Stats Perform Portal`;
      window.dispatchEvent(new Event('titlechange'));
    }, [location]);

    return (
      <ComposedComponent {...props} />
    );
  };

  return ComponentWithTitle;
}

export default withTitle;